export const myToysPage = {
    'my.toys.page.title': 'My toys',
    'my.toys.page.toy.for.sale.modal.title': 'The toy is for sale',
}
